import { useState } from "react";

const useInteractiveMap = (initialProps = {}) => {
  const [stateInteractiveMap, setState] = useState({
    hoveredCountry: null,
    selectedCountry: null,
  });

  const setInteractiveMap = (field, value) => {
    if (typeof field === "object") {
      setState((prevState) => ({ ...prevState, ...field }));
    } else {
      setState((prevState) => ({ ...prevState, [field]: value }));
    }
  };

  const toggleInteractiveMapField = (field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return {
    stateInteractiveMap,
    setInteractiveMap,
    toggleInteractiveMapField,
  };
};

export default useInteractiveMap;
